export const VENOM_ANALYSIS_HEADERS = [
    {
        header: "Analysis Date",
        key: "AnalysisDate",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Name",
        key: "Name",
        width: 60,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Low Range",
        key: "LowRange",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "High Range",
        key: "HighRange",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Comments",
        key: "Comments",
        width: 100,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Attachment",
        key: "Attachment",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
];

export const EXTRACTION_HEADERS = [
    {
        header: "Barcode",
        key: "Barcode",
        width: 30,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Session Date",
        key: "SessionDate",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Room",
        key: "RoomName",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Rack Number",
        key: "RackNumber",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Species",
        key: "SpeciesFullName",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Weight",
        key: "Weight",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Comment",
        key: "Comment",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Session Start Time",
        key: "SessionStartTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Session Start User",
        key: "SessionStartUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Session End Time",
        key: "SessionEndTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Session End User",
        key: "SessionEndUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Venom Refrigerated Time",
        key: "VenomRefrigeratedTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Venom Refrigerated User",
        key: "VenomRefrigeratedUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
]

export const SPECIMEN_HEADERS = [
    {
        header: "Specimen ID",
        key: "SpecimenDisplayID",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Species",
        key: "SpeciesFullName",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Supplier",
        key: "SupplierName",
        width: 30,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Arrival Date",
        key: "ArrivalDate",
        width: 25,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Arrival Weight",
        key: "ArrivalWeight",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Current Weight",
        key: "CurrentWeight",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Location Type",
        key: "LocationTypeText",
        width: 30,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Room",
        key: "RoomText",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Suite Number",
        key: "SuiteNumberText",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Rack Number",
        key: "RackNumber",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Drawer",
        key: "DrawerText",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Geographical Location",
        key: "GeographicalLocationName",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Gender",
        key: "Gender",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Deceased",
        key: "Deceased",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Miscellaneous Information",
        key: "MiscellaneousInformation",
        width: 100,
        style: {
            alignment: {
                wrapText: true
            }
        }
    }
];

export const EXTRACTION_ENTRY_HEADERS = [
    {
        header: "Specimen ID",
        key: "SpecimenDisplayID",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Primary Extractor",
        key: "PrimaryExtractorUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Assistant Extractor",
        key: "AssistantExtractorUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Husbandry Performed",
        key: "HusbandryPerformed",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Geographical Location",
        key: "GeographicalLocationName",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Venom Collected",
        key: "VenomCollected",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Collection Comment",
        key: "CollectionComment",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Recorded At",
        key: "RecordedAt",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    }, {
        header: "SpecimenSkipMed",
        key: "SpecimenSkipMed",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenSkipPoorFeed",
        key: "SpecimenSkipPoorFeed",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenSkipBehavior",
        key: "SpecimenSkipBehavior",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenCoolTimeTemp",
        key: "SpecimenCoolTimeTemp",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenTSC",
        key: "SpecimenTSC",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenBSC",
        key: "SpecimenBSC",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Specimen2CVB",
        key: "Specimen2CVB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenBankedIn",
        key: "SpecimenBankedIn",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenRanIn",
        key: "SpecimenRanIn",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenAssist",
        key: "SpecimenAssist",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenBackedOut",
        key: "SpecimenBackedOut",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenStriking",
        key: "SpecimenStriking",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenLunging",
        key: "SpecimenLunging",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenWanders",
        key: "SpecimenWanders",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenSpaz",
        key: "SpecimenSpaz",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenAGG",
        key: "SpecimenAGG",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "SpecimenDIFF",
        key: "SpecimenDIFF",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionPF1",
        key: "ExtractionPF1",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionPF2",
        key: "ExtractionPF2",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionPF3",
        key: "ExtractionPF3",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionPF4",
        key: "ExtractionPF4",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionPF5",
        key: "ExtractionPF5",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionPFPreCut",
        key: "ExtractionPFPreCut",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTape1",
        key: "ExtractionTape1",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTape2",
        key: "ExtractionTape2",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTape3",
        key: "ExtractionTape3",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTape4",
        key: "ExtractionTape4",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTape5",
        key: "ExtractionTape5",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionAPPSet1",
        key: "ExtractionAPPSet1",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionAPPSet2",
        key: "ExtractionAPPSet2",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionAPPSet3",
        key: "ExtractionAPPSet3",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionAPPSet4",
        key: "ExtractionAPPSet4",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionHT",
        key: "ExtractionHT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionSD",
        key: "ExtractionSD",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionRBS",
        key: "ExtractionRBS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionBON",
        key: "ExtractionBON",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionFunnelXS",
        key: "ExtractionFunnelXS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionFunnelS",
        key: "ExtractionFunnelS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionFunnelM",
        key: "ExtractionFunnelM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionFunnelL",
        key: "ExtractionFunnelL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionFunnelXL",
        key: "ExtractionFunnelXL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionFunnelJ",
        key: "ExtractionFunnelJ",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionGlass",
        key: "ExtractionGlass",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionPlexi",
        key: "ExtractionPlexi",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTubeXS",
        key: "ExtractionTubeXS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTubeS",
        key: "ExtractionTubeS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTubeM",
        key: "ExtractionTubeM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTubeL",
        key: "ExtractionTubeL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTubeXL",
        key: "ExtractionTubeXL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionTubeJ",
        key: "ExtractionTubeJ",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionSoft",
        key: "ExtractionSoft",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionHard",
        key: "ExtractionHard",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionLong",
        key: "ExtractionLong",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "ExtractionBlack",
        key: "ExtractionBlack",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinLOTPTLS",
        key: "PinLOTPTLS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinLOTPTNS",
        key: "PinLOTPTNS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinLOTPTCAIP",
        key: "PinLOTPTCAIP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinNTOS",
        key: "PinNTOS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinTPF",
        key: "PinTPF",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinTPC",
        key: "PinTPC",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinJHL",
        key: "PinJHL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinJHR",
        key: "PinJHR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinSquirm",
        key: "PinSquirm",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pin1TPB",
        key: "Pin1TPB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pin2TPB",
        key: "Pin2TPB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinBP",
        key: "PinBP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinAP",
        key: "PinAP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinShortBurst",
        key: "PinShortBurst",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pin1HRT",
        key: "Pin1HRT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pin2HRT",
        key: "Pin2HRT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinTNU",
        key: "PinTNU",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinExtreme",
        key: "PinExtreme",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinT",
        key: "PinT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinTDD",
        key: "PinTDD",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinTCP",
        key: "PinTCP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinLE",
        key: "PinLE",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinLockFinger",
        key: "PinLockFinger",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinLP",
        key: "PinLP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinMP",
        key: "PinMP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinHP",
        key: "PinHP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinLB",
        key: "PinLB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinMB",
        key: "PinMB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinHB",
        key: "PinHB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinDropJaws",
        key: "PinDropJaws",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinSWL",
        key: "PinSWL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinSWR",
        key: "PinSWR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinPushF",
        key: "PinPushF",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinPushB",
        key: "PinPushB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinCountered",
        key: "PinCountered",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinRollL",
        key: "PinRollL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinRollM",
        key: "PinRollM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinRollU",
        key: "PinRollU",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinRollDR",
        key: "PinRollDR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinRollCKS",
        key: "PinRollCKS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinStandard",
        key: "PinStandard",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinWP",
        key: "PinWP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinSK",
        key: "PinSK",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinCH",
        key: "PinCH",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinSHO",
        key: "PinSHO",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinAIH",
        key: "PinAIH",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinB3LT",
        key: "PinB3LT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinB3OP",
        key: "PinB3OP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinFO",
        key: "PinFO",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinFOM",
        key: "PinFOM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinFML",
        key: "PinFML",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinFMR",
        key: "PinFMR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinCrossbarLT",
        key: "PinCrossbarLT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinCrossbarM",
        key: "PinCrossbarM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinTORL",
        key: "PinTORL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinTORR",
        key: "PinTORR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinPTL",
        key: "PinPTL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinPTR",
        key: "PinPTR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinForearmLT",
        key: "PinForearmLT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinForearmM",
        key: "PinForearmM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinSPP",
        key: "PinSPP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FXRP",
        key: "FXRP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinMWS",
        key: "PinMWS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinBSNT",
        key: "PinBSNT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinBST",
        key: "PinBST",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "PinAnglePullAborted",
        key: "PinAnglePullAborted",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelLP",
        key: "FunnelLP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelMP",
        key: "FunnelMP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelHP",
        key: "FunnelHP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelLB",
        key: "FunnelLB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelMB",
        key: "FunnelMB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelHB",
        key: "FunnelHB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelSquirm",
        key: "FunnelSquirm",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelSWL",
        key: "FunnelSWL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelSWR",
        key: "FunnelSWR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelPushF",
        key: "FunnelPushF",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelPushB",
        key: "FunnelPushB",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelShortBurst",
        key: "FunnelShortBurst",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelRollL",
        key: "FunnelRollL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelRollM",
        key: "FunnelRollM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelRollU",
        key: "FunnelRollU",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelRollDR",
        key: "FunnelRollDR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelRollCKS",
        key: "FunnelRollCKS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelExtreme",
        key: "FunnelExtreme",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelWP",
        key: "FunnelWP",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelSK",
        key: "FunnelSK",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelCH",
        key: "FunnelCH",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelSHO",
        key: "FunnelSHO",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelAIH",
        key: "FunnelAIH",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelLockFinger",
        key: "FunnelLockFinger",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelHMOWTL",
        key: "FunnelHMOWTL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelHMOWTR",
        key: "FunnelHMOWTR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelMWS",
        key: "FunnelMWS",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelDropJaws",
        key: "FunnelDropJaws",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelHMOWALeave",
        key: "FunnelHMOWALeave",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelHMOWARemoved",
        key: "FunnelHMOWARemoved",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelCountered",
        key: "FunnelCountered",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelWFT",
        key: "FunnelWFT",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelLOF",
        key: "FunnelLOF",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelCM",
        key: "FunnelCM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelCoax",
        key: "FunnelCoax",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelCFO",
        key: "FunnelCFO",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelOMWA",
        key: "FunnelOMWA",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelTBM",
        key: "FunnelTBM",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelBOF",
        key: "FunnelBOF",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelLKF",
        key: "FunnelLKF",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelPTC",
        key: "FunnelPTC",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelRWA",
        key: "FunnelRWA",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelDNRFL",
        key: "FunnelDNRFL",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelDNRFR",
        key: "FunnelDNRFR",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelNBPlus",
        key: "FunnelNBPlus",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelVH",
        key: "FunnelVH",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelVHPlus",
        key: "FunnelVHPlus",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelSQ",
        key: "FunnelSQ",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelNoBite",
        key: "FunnelNoBite",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelNoVenom",
        key: "FunnelNoVenom",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelBite",
        key: "FunnelBite",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelBulldog",
        key: "FunnelBulldog",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelChewing",
        key: "FunnelChewing",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelClimbing",
        key: "FunnelClimbing",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelHolding",
        key: "FunnelHolding",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelPulse",
        key: "FunnelPulse",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelStabbing",
        key: "FunnelStabbing",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Funnel180",
        key: "Funnel180",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelBiteTime",
        key: "FunnelBiteTime",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "FunnelMXPercentOfVenomCollected",
        key: "FunnelMXPercentOfVenomCollected",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Comment",
        key: "Comment",
        width: 100,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
];

export const SPECIES_BATCH_POOL_HEADERS = [
    {
        header: "Barcode",
        key: "Barcode",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    }, 
    {
        header: "Species",
        key: "SpeciesFullName",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pool Created By",
        key: "CreatedByUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pool Created Time",
        key: "CreatedTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pool Closed By",
        key: "ClosedByUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pool Closed Time",
        key: "ClosedTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Total Weight",
        key: "TotalWeight",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
]

export const SPECIES_BATCH_POOL_IN_VENOM_LOT_HEADERS = [
    ...SPECIES_BATCH_POOL_HEADERS,
    {
        header: "Total Weight Added to Venom Lot",
        key: "TotalWeightAddedToThisVenomLot",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
];

export const MONTHLY_POOL_HEADERS = [
    {
        header: "Barcode",
        key: "Barcode",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    }, 
    {
        header: "Species",
        key: "SpeciesFullName",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Year",
        key: "Year",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Month",
        key: "Month",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pool Created By",
        key: "PoolCreatedByUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pool Created Time",
        key: "PoolCreatedTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pool Closed By",
        key: "PoolClosedByUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Pool Closed Time",
        key: "PoolClosedTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "In Species Batch Pool",
        key: "InSpeciesBatchPool",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Total Weight",
        key: "TotalWeight",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
];

export const MONTHLY_POOL_DAILY_EXTRACTION_HEADERS = [
    {
        header: "Barcode",
        key: "Barcode",
        width: 30,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Room",
        key: "RoomName",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Rack Number",
        key: "RackNumber",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Session Start Time",
        key: "SessionStartTime",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Weight",
        key: "Weight",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
]

export const MONTHLY_POOL_EXTERNALLY_SUPPLIED_HEADERS = [
    {
        header: "Supplier",
        key: "SupplierName",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Supplier Reference Number",
        key: "SupplierReferenceNumber",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Weight",
        key: "Weight",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
]

export const VENOM_LOT_HEADERS = [
    {
        header: "Barcode",
        key: "Barcode",
        width: 20,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Species",
        key: "SpeciesFullName",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Created By",
        key: "CreatedByUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Created Time",
        key: "CreatedTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Closed By",
        key: "ClosedByUser",
        width: 50,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Closed Time",
        key: "ClosedTime",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "Total Weight",
        key: "TotalWeight",
        width: 10,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "QA Appearance",
        key: "QAAppearance",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "QA Comments",
        key: "QAComments",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "QA Protocol Analysis",
        key: "QAProtocolAnalysis",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "QA Quality",
        key: "QAQuality",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "QA Result",
        key: "QAResult",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
    {
        header: "QA Lot Numbers",
        key: "QALotNumbers",
        width: 40,
        style: {
            alignment: {
                wrapText: true
            }
        }
    },
]